import React, {useEffect, useState} from 'react';
import TextInput from '../TextInput/TextInput';

import * as S from './TradingLicenseDetails.styles';
import * as C from '../../../OnboardingNew/Common.styles';

const TradingLicenseDetails = ({
  responseData,
  setTrnNumber,
  busineesDetails,
  setBusinessDetails,
  showEmirates=true,
  allowPastDate=true
}) => {
  const {data, is_editable = false} = responseData || {};

  const handleDropdownSelection = (e, titleField = true) => {
    if (!e.target.value) return;
    const obj = busineesDetails;
    if (titleField) obj['title'] = e.target.value;
    else obj['emirates'] = e.target.value;
    setBusinessDetails({...obj});
  };

  return (
    <S.Container>
      <S.Heading>
        <p>
          BUSINESS DETAILS <span>(As per your trading license)</span>
        </p>
        <span></span>
      </S.Heading>
      {!is_editable ? (
        <S.TrdList>
          <S.TrdListItem>
            <S.TrdListItemLbl>Business Name</S.TrdListItemLbl>
            <S.TrdListItemDesc>
              <p>{data?.business_name}</p>
            </S.TrdListItemDesc>
          </S.TrdListItem>
          <S.TrdListItem>
            <S.TrdListItemLbl>Expiry Date</S.TrdListItemLbl>
            <S.TrdListItemDesc>
              <p>{data?.expiry_date}</p>
            </S.TrdListItemDesc>
          </S.TrdListItem>
          <S.TrdListItem>
            <S.TrdListItemLbl>Address</S.TrdListItemLbl>
            <S.TrdListItemDesc>
              <p>{data?.address}</p>
            </S.TrdListItemDesc>
          </S.TrdListItem>
          <S.TrdListItem>
            <S.TrdListItemLbl>Business Description</S.TrdListItemLbl>
            <S.TrdListItemDesc>
              <p>{data?.business_desc}</p>
            </S.TrdListItemDesc>
          </S.TrdListItem>
          {showEmirates && <S.TrdListItem>
            <S.TrdListItemLbl>Emirates</S.TrdListItemLbl>
            <S.TrdListItemDesc>
              <p>{data?.emirates}</p>
            </S.TrdListItemDesc>
          </S.TrdListItem>}
        </S.TrdList>
      ) : (
        <S.TrdList>
          <S.TrdListItem>
            <S.TrdListItemLbl>Business Name</S.TrdListItemLbl>
            <S.TrdListItemDesc>
              <TextInput
                placeholder={'Enter Business Name'}
                //classes={'appendTop30'}
                haserror={false}
                mobileNumber={false}
                inputType={'text'}
                endIcon="sprite ic_eye"
                setterFunction={setBusinessDetails}
                name={'business_name'}
                component={'businessUploadDetails'}
                setterObj={busineesDetails}
                setMargin={false}
                stringValue={busineesDetails?.business_name || ''}
              />
            </S.TrdListItemDesc>
          </S.TrdListItem>
          <S.TrdListItem>
            <S.TrdListItemLbl>Expiry Date</S.TrdListItemLbl>
            <S.TrdListItemDesc>
              <TextInput
                placeholder={'Enter Expiry Date'}
                //classes={'appendTop30'}
                haserror={false}
                mobileNumber={false}
                inputType={'text'}
                endIcon="sprite ic_eye"
                setterFunction={setBusinessDetails}
                name={'expiry_date'}
                component={'businessUploadDetails'}
                setterObj={busineesDetails}
                type="Date"
                setMargin={false}
                stringValue={busineesDetails?.expiry_date || ''}
                allowPastDate={allowPastDate}
              />
            </S.TrdListItemDesc>
          </S.TrdListItem>
          <S.TrdListItem>
            <S.TrdListItemLbl>Address</S.TrdListItemLbl>
            <S.TrdListItemDesc>
              <TextInput
                placeholder={'Enter Address'}
                //classes={'appendTop30'}
                haserror={false}
                mobileNumber={false}
                inputType={'text'}
                endIcon="sprite ic_eye"
                setterFunction={setBusinessDetails}
                name={'address'}
                component={'businessUploadDetails'}
                setterObj={busineesDetails}
                setMargin={false}
                stringValue={busineesDetails?.address || ''}
              />
            </S.TrdListItemDesc>
          </S.TrdListItem>
          <S.TrdListItem>
            <S.TrdListItemLbl>Business Description</S.TrdListItemLbl>
            <S.TrdListItemDesc>
              <TextInput
                placeholder={'Enter Business Discription'}
                //classes={'appendTop30'}
                haserror={false}
                mobileNumber={false}
                inputType={'text'}
                endIcon="sprite ic_eye"
                setterFunction={setBusinessDetails}
                name={'business_desc'}
                component={'businessUploadDetails'}
                setterObj={busineesDetails}
                setMargin={false}
                stringValue={busineesDetails?.business_desc || ''}
              />
            </S.TrdListItemDesc>
          </S.TrdListItem>
          {showEmirates && <S.TrdListItem>
            <S.TrdListItemLbl>Emirates</S.TrdListItemLbl>
            <C.CommonSelect
              value={busineesDetails?.emirates}
              onChange={e => handleDropdownSelection(e, false)}
            >
              <option value="">Select</option>
              <option value="Abu Dhabi">Abu Dhabi</option>
              <option value="Dubai">Dubai</option>
              <option value="Sharjah">Sharjah</option>
              <option value="Ajman">Ajman</option>
              <option value="Umm Al-Quwain">Umm Al-Quwain</option>
              <option value="Fujairah">Fujairah</option>
              <option value="Ras Al Khaimah">Ras Al Khaimah</option>
            </C.CommonSelect>
          </S.TrdListItem>}
        </S.TrdList>
      )}
    </S.Container>
  );
};

export default TradingLicenseDetails;
